import React, { Component } from 'react'
import styled from 'styled-components'

import logo from '../../../images/logo_mysquare.svg'

/**
|--------------------------------------------------
| Header
|--------------------------------------------------
*/
export const LoginHeaderWrapper = styled.div`
  text-align: center;
  background-color: transparent;
  transition: background 0.5s ease;
`

export const LogoWrapper = styled.div`
  margin-bottom: 15px;
  display: inline-block;
  img {
    width: 190px;
    object-fit: cover;
  }
`

export const ImageText = styled.div`
  text-align: left;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 5px;
  color: #fff;
  display: block;
`

class WelcomeHeader extends Component {
  render () {
    return (
      <LoginHeaderWrapper>
        <LogoWrapper>
          <ImageText>Welcome to</ImageText>
          <img src={logo} alt='My Square' />
        </LogoWrapper>
      </LoginHeaderWrapper>
    )
  }
}
export default WelcomeHeader



// WEBPACK FOOTER //
// ./src/layouts/NonAuthenticated/components/WelcomeHeader.js